import { render, staticRenderFns } from "./CreateColorCategory.vue?vue&type=template&id=9332f00e&"
import script from "./CreateColorCategory.vue?vue&type=script&lang=js&"
export * from "./CreateColorCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports